export default {
    props: {
        grow: {
            type: Boolean,
            default: undefined
        },
        shrink: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        responsiveClasses() {
            return {
                'flex-grow': (this.grow || this.grow === undefined) && !this.shrink && this.cols === undefined,
                // 'flex-grow-0': !this.grow, Might not be needed,
                'flex-shrink': this.shrink && !this.grow && this.cols === undefined,
                // 'flex-shrink-0': !this.shrink, Might not be needed
            };
        }
    }
};